import React, { useContext } from 'react';
import PropTypes from "prop-types";
import FormRow from "../../../../Components/HorizontalForm/FormRow";
import CategoryTermsCheckbox from "../../Components/CategoryTermsCheckbox";
import { BookingFormContext } from "../BookingFormProvider";

const BookingFormTermsConditions = (props) => {

    const {
        category,
        booking,
        errors,

        onBookingFormChange,
        editBookingId,
    } = useContext(BookingFormContext);

    if ((editBookingId) || !category.terms_required) {
        return null;
    }

    return (<>
        <FormRow
            errorMessage={errors.terms_accepted}
        >
            <CategoryTermsCheckbox
                checked={booking.terms_accepted}
                terms={category.terms}
                onChange={onBookingFormChange}
            />
        </FormRow>
    </>);
};

BookingFormTermsConditions.propTypes = {};

BookingFormTermsConditions.defaultProps = {};

export default BookingFormTermsConditions;
